export enum PaymentDataType {
  MPCard = 'mpcard',
  StripeCard = 'stripe',
  MetroBank = 'metrob',
  CyberSource = 'cybers',
}
